import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { PhoneFrame, LbTabs, DemoCaption } from './PhoneFrame';
import { AVATARS, CROWNS, FLAGS } from './assets';
import { SETTLE, TEAM_NAMES, CHAMPION_BONUS } from './data';

const K = 'caseStudies.worldCup.settle';
// Rows are absolutely positioned so they can animate into their new
// order; 44px is the app's own mobile .lb-row height.
const ROW_H = 44;
const GAP = 8;

const Arrow = ({ dir }) => (
  <span className={`lb-arrow ${dir}`} aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="#FFF" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="15 5 8 12 15 19" />
    </svg>
  </span>
);

const SettleWidget = ({ lang }) => {
  const { t } = useTranslation();
  const [crowned, setCrowned] = useState(false);

  const rows = SETTLE.map((d) => {
    const winner = crowned && d.hit;
    return { ...d, winner, pts: d.base + (winner ? CHAMPION_BONUS : 0) };
  });
  const settled = rows.filter((r) => r.winner).length * CHAMPION_BONUS;
  const order = [...rows].sort((a, b) => b.pts - a.pts);
  // Tie-aware crowns: the top-3 DISTINCT scores share tiers, same rule as
  // the real bonus tab. (The app's gold/silver/bronze row borders are
  // switched off in Leaderboard.css; only the crowns mark the podium.)
  const podium = [...new Set(rows.map((r) => r.pts).filter((p) => p > 0))].sort((a, b) => b - a).slice(0, 3);

  return (
    <figure className="demo">
      <DemoCaption title={t(`${K}.title`)} note={t(`${K}.note`)} />
      <PhoneFrame lang={lang}>
        <div className="scr-body">
          <LbTabs active="bonus" />
          <div className="lb-bonus">
            <div className="lb-bonus-nav">
              <Arrow dir="back" />
              <div className="lb-bonus-card">
                <span className="lb-bonus-card-title">{t(`${K}.question`)}</span>
                <span className="lb-bonus-card-points">{t(`${K}.scoring`)}</span>
              </div>
              <Arrow dir="fwd" />
            </div>
            <div className="lb-list">
              <div className="rows-anim" style={{ height: SETTLE.length * ROW_H + (SETTLE.length - 1) * GAP }}>
                {/* Rendered in a fixed order; only `top` changes, so the CSS transition animates the re-sort. */}
                {rows.map((r) => {
                  const pos = order.indexOf(r);
                  const tier = podium.indexOf(r.pts);
                  return (
                    <div className="lb-row" key={r.en} style={{ top: pos * (ROW_H + GAP) }}>
                      <span className="lb-rank">{pos + 1}</span>
                      <div className="lb-user">
                        <img className="av" src={AVATARS[r.avatar]} alt="" />
                        <span className="lb-name">{r[lang]}</span>
                      </div>
                      <span className={`lb-pick${r.winner ? ' hit' : ''}`}>{TEAM_NAMES[lang][r.team]}</span>
                      <span className="lb-crown">{tier >= 0 && <img src={CROWNS[tier]} alt="" />}</span>
                      <span className="lb-pts">
                        {r.pts}
                        <span className={`lb-delta${r.winner ? ' show' : ''}`}>25+</span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </PhoneFrame>
      <div className="demo-foot">
        <button className={`settle-btn${crowned ? ' on' : ''}`} type="button" onClick={() => setCrowned((c) => !c)}>
          <img src={FLAGS.Spain} alt="" /> {t(`${K}.${crowned ? 'uncrown' : 'crown'}`)}
        </button>
        <p className="settle-status" aria-live="polite">
          {crowned
            ? <Trans i18nKey={`${K}.done`} values={{ settled }} components={{ b: <b /> }} />
            : t(`${K}.idle`)}
        </p>
      </div>
    </figure>
  );
};

export default SettleWidget;
